// extracted by mini-css-extract-plugin
export default {"downloadIcon":"styles_downloadIcon__jSxkN"};